import { render, staticRenderFns } from "./curriculumDocument.vue?vue&type=template&id=0070ff49&scoped=true"
import script from "./curriculumDocument.vue?vue&type=script&lang=js"
export * from "./curriculumDocument.vue?vue&type=script&lang=js"
import style0 from "./curriculumDocument.vue?vue&type=style&index=0&id=0070ff49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070ff49",
  null
  
)

export default component.exports